"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asteroid = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var Asteroid = (function (_super) {
    __extends(Asteroid, _super);
    function Asteroid() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.ASTEROID,
            tags: [Tags_1.Tags.SPACE],
            cost: 14,
            tr: { temperature: 1 },
            metadata: {
                description: 'Raise temperature 1 step and gain 2 titanium. Remove up to 3 Plants from any player.',
                cardNumber: '009',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.temperature(1).br;
                    b.titanium(2).br;
                    b.minus().plants(-3, { all: Options_1.all });
                }),
            },
        }) || this;
    }
    Asteroid.prototype.play = function (player) {
        player.game.increaseTemperature(player, 1);
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 3));
        player.titanium += 2;
        return undefined;
    };
    return Asteroid;
}(Card_1.Card));
exports.Asteroid = Asteroid;
